import type { BalanceEntryDto, LiquidityPositionDto } from '../../app/api/generated/client';
import { WEALTH_ASSET_BANKABLE_CATEGORY_ID } from '../../app/config/constants';

/**
 * Builds the payload expected by {@link BalanceEntryModalWrapper} from liquidity API fields only
 * (no balance-sheet query).
 */
export function buildModalBalanceEntryFromLiquidityRow(row: LiquidityPositionDto): BalanceEntryDto {
    return {
        qualifiedId: row.qualifiedId,
        qualifiedKey: row.qualifiedKey,
        categoryId: row.categoryId ?? WEALTH_ASSET_BANKABLE_CATEGORY_ID,
        businessRelationId: row.businessRelationId,
        portfolioNumber: row.portfolioNumber,
        name: row.name,
        referenceAmount: row.referenceMarketValue,
        referenceCurrency: row.referenceCurrency,
        currency: row.currency,
        amount: row.marketValue,
        investmentStrategy: row.investmentStrategy,
        type: row.balanceEntryType,
        investmentStrategyRequired: row.investmentStrategyRequired,
        fromToDatesAllowed: row.fromToDatesAllowed,
        fromDate: row.fromDate,
        toDate: row.toDate,
        assetClassBreakdown: row.assetClassBreakdown,
    } as BalanceEntryDto;
}
